<template>
  <div class="row text-center pt-4 powered-by">
    <div class="col-sm-2 hidden"></div>
    <div class="col-12 col-sm-8">
      <div class="mb-2">
        <small class="text-muted">En tjänst från TecknaEl</small>
      </div>
      <div>
        <a href="https://tecknael.se" target="_blank">
          <img src="http://cdn.tecknael.se/images/misc/logo-color.png">
        </a>
      </div>
    </div>
    <div class="col-sm-2 hidden"></div>
  </div>
</template>

<script>
  export default {
    name: "PoweredBy",
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Partials/PoweredBy.vue